"use client";
import { Container } from "react-bootstrap";
import { ArrowLeftOutlined, ArrowRightOutlined, LeftOutlined } from "@ant-design/icons";
import { Button, Grid, Popover, Descriptions } from "antd";
import PropTypes, { func } from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { useState, useMemo, useEffect } from "react";
import AddPatientPopup from "../appointmentBooking/AddPatientPopUp";
import { propTypes } from "react-bootstrap/esm/Image";
import { HeartFilled, MedicineBoxFilled } from "@ant-design/icons"; // Make sure to import these

const { useBreakpoint } = Grid;

const Consultant_Header = ({
  patient,
  previewRx,
  autoSave,
  refresh,
  step,
  setStep,
}) => {
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [editPatient, setEditPatient] = useState(false);
  const [patientDetail, setPatientDetail] = useState(patient);
  const [showVaccination, setShowVaccination] = useState(false);

  const containerStyle = {
    padding: screens.xs ? "0px 0px" : "0px 0px",
  };

  const patientNameStyle = {
    fontSize: screens.xs
      ? "19.2px"
      : "19.2px",
    marginBottom: 0,
  };

  const patientInfoStyle = {
    fontSize: screens.xs
      ? "17.2px"
      : "17.2px",
  };
  const patientContainerStyle = {
  backgroundColor: '#1890ff', // A strong blue color, adjust if needed
  margin:"-7px 0px -7px 0px",
  padding: "3px 10px",
  color: 'white',
  textAlign: 'center',
  borderRadius: '0', // If you have default border-radius, ensure it's removed for sharp edges
  // You might want to control width based on its parent container
};

  const buttonStyle = {
    fontSize: screens.xs ? "0.7rem" : "0.9rem",
    height: screens.xs ? "28px" : "40px",
    padding: screens.xs ? "0 8px" : "0 12px",
  };
  const handleClose = (data) => {
    console.log("updated data", data);
    setEditPatient(false);
    if (data && Object.keys(data).length > 0) {
      setPatientDetail(data);
      refresh();
    }
  };

  // Exclude unneeded fields
  const excludedFields = [
    "id",
    "hospital_id",
    "office_id",
    "created_at",
    "updated_at",
    "flag",
    "group",
  ];

  // Filter valid patient data
  const patientData = useMemo(
    () =>
      Object.entries(patientDetail || {})
        .filter(([key, value]) => value && !excludedFields.includes(key))
        .map(([key, value]) => ({
          label: key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase()), // format labels like First Name
          value: value.toString(),
        })),
    [patientDetail]
  );

  // Split data into two halves for 2-column layout
  const midIndex = Math.ceil(patientData.length / 2);
  const firstHalf = patientData.slice(0, midIndex);
  const secondHalf = patientData.slice(midIndex);

  const popoverContent = (
    <div
      style={{
        maxWidth: "850px",
        minWidth: "400px",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
        padding: "20px",
        position: "relative",
        zIndex: 1000, // make sure it’s above the blur
      }}
    >
      <h3
        style={{
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "700",
          color: "#1677ff",
          marginBottom: "16px",
        }}
      >
        Patient Details
      </h3>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: screens.xs ? "1fr" : "1fr 1fr",
          gap: "14px",
        }}
      >
        <Descriptions
          size="middle"
          bordered
          column={1}
          contentStyle={{ fontSize: "18px", fontWeight: 600, color: "#333" }}
          labelStyle={{
            fontWeight: "700",
            width: "40%",
            background: "#f9fafb",
            color: "#555",
            fontSize: "16px",
          }}
        >
          {firstHalf.map(({ label, value }) => (
            <Descriptions.Item key={label} label={label}>
              {value}
            </Descriptions.Item>
          ))}
        </Descriptions>

        <Descriptions
          size="middle"
          bordered
          column={1}
          contentStyle={{ fontSize: "18px", fontWeight: 600, color: "#333" }}
          labelStyle={{
            fontWeight: "700",
            width: "40%",
            background: "#f9fafb",
            color: "#555",
            fontSize: "16px",
          }}
        >
          {secondHalf.map(({ label, value }) => (
            <Descriptions.Item key={label} label={label}>
              {value}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </div>

      <div
        style={{
          textAlign: "right",
          marginTop: "18px",
          borderTop: "1px solid #e8e8e8",
          paddingTop: "10px",
        }}
      >
        <Button
          size="middle"
          type="primary"
          style={{
            fontWeight: "600",
            borderRadius: "8px",
            padding: "4px 16px",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setPopoverVisible(false);
            setTimeout(() => setEditPatient(true), 100);
          }}
        >
          Edit
        </Button>
      </div>
    </div>
  );
  const [isBlurActive, setIsBlurActive] = useState(false);

  useEffect(() => {
    // Add or remove blur overlay dynamically
    const existingOverlay = document.getElementById("blur-overlay");

    if (popoverVisible) {
      if (!existingOverlay) {
        const overlay = document.createElement("div");
        overlay.id = "blur-overlay";
        Object.assign(overlay.style, {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          zIndex: 999, // below popover
          transition: "all 0.3s ease",
        });
        overlay.addEventListener("click", () => setPopoverVisible(false));
        document.body.appendChild(overlay);
      }
      setIsBlurActive(true);
    } else {
      if (existingOverlay) {
        existingOverlay.remove();
      }
      setIsBlurActive(false);
    }

    return () => {
      const cleanupOverlay = document.getElementById("blur-overlay");
      if (cleanupOverlay) cleanupOverlay.remove();
    };
  }, [popoverVisible]);

  const stepStyle = (isActive) => ({
    cursor: "pointer",
    fontWeight: isActive ? "bold" : "normal",
    fontSize: screens.xs ? "0.9rem" : "1.1rem",
    // Text color follows the step's primary color when active, gray when inactive
    color: isActive ? "#1890ff" : "#555",
    // padding: screens.xs ? "4px 8px" : "8px 16px",
    borderBottom: isActive ? "3px solid #1890ff" : "3px solid transparent",
    transition: "all 0.3s ease-in-out",
    whiteSpace: "nowrap",
    // --- CHANGES FOR ONE-LINE LAYOUT ---
    display: "flex",
    flexDirection: "row", // Set to row for horizontal layout
    alignItems: "center", // Vertically center the icon and text
    justifyContent: "center",
  });

  return (
    <Container fluid style={containerStyle}>
      <div
        className="d-flex align-items-center justify-content-between" // Use justify-content-between for equal spacing
        style={{
          minWidth: 0,
          flexWrap: screens.xs ? "wrap" : "nowrap",
          // Use flex-grow on the middle element to push the sides away
        }}
      >
        {/* LEFT SECTION: Patient Info (Back Arrow & Name) - flex-shrink-0 to keep its size */}
        <div
          className="d-flex align-items-center flex-shrink-0"
          style={{ marginRight: screens.xs ? "8px" : "12px" }}
        >
          {step=="Symptoms" &&<Link
            className="me-2"
            to="/doctor-dashboard"
            onClick={() => {autoSave()}}
          >
            <ArrowLeftOutlined
              style={{
                fontSize: screens.xs ? "20px" : "25px",
                textShadow: "0 0 1px #000",
                fontWeight: "bold",
              }}
            />
          </Link>}
          {step=="Treatment" &&<Link
            className="me-2"
            onClick={() => {autoSave(),setStep("Symptoms")}}
          >
            <ArrowLeftOutlined
              style={{
                fontSize: screens.xs ? "20px" : "25px",
                textShadow: "0 0 1px #000",
                fontWeight: "bold",
              }}
            />
          </Link>
          }
          <Popover
            content={popoverContent}
            trigger="click"
            open={popoverVisible}
            onOpenChange={setPopoverVisible}
            placement="bottomLeft"
            destroyTooltipOnHide // ✅ ensures safe cleanup
          >
            <div
              onClick={() => setPopoverVisible(!popoverVisible)}
              style={{ ...patientContainerStyle, cursor: "pointer" }} // Apply the new container style
            >
              <h5 style={patientNameStyle}>
                {`${patientDetail?.first_name ?? ""} ${
                  patientDetail?.last_name ?? ""
                }`}
              </h5>
              <small style={patientInfoStyle}>
                {" "}
                {/* Apply the new info style */}
                {`${patientDetail?.gender} | ${patientDetail?.age}`}
              </small>
            </div>
          </Popover>
        </div>
        {editPatient && (
          <AddPatientPopup
            show={editPatient}
            handleClose={handleClose}
            editpatientsdetail={patientDetail}
          />
        )}

        {/* CENTER SECTION: Step Navigation (Symptoms/Treatment) - flex-grow-1 to take center space */}
        {showVaccination && <div
          className="d-flex align-items-center justify-content-center flex-grow-1"
          style={{
            minWidth: screens.xs ? "100%" : "auto",
            order: screens.xs ? 3 : 2,
            margin: screens.xs ? "8px 0" : "0 20px",
          }}
        >
          <div
            style={stepStyle(step === "Vaccination")}
            onClick={() => setStep && setStep("Vaccination")}
          >
            {/* Treatment Icon */}
            <span
              style={{
                fontSize: screens.xs ? "24px" : "30px",
                color: step === "Vaccination" ? "#52c41a" : "#999", // Green for Active, Gray for Inactive
                marginRight: "8px",
              }}
            >
              <MedicineBoxFilled />
            </span>
            Vaccination
          </div>
        </div>}
        <div
          className="d-flex align-items-center justify-content-center flex-grow-1"
          style={{
            minWidth: screens.xs ? "100%" : "auto",
            order: screens.xs ? 3 : 2,
            margin: screens.xs ? "8px 0" : "0 20px",
          }}
        >
          <div
            style={stepStyle(step == "Symptoms")}
            onClick={() => setStep && setStep("Symptoms")}
          >
            {/* Symptoms Icon */}
            <span
              style={{
                fontSize: screens.xs ? "24px" : "30px",
                color: step === "Symptoms" ? "#ff4d4f" : "#999",
                marginRight: "8px",
              }}
            >
              <HeartFilled />
            </span>
            Symptoms
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-center flex-grow-1"
          style={{
            minWidth: screens.xs ? "100%" : "auto",
            order: screens.xs ? 3 : 2,
            margin: screens.xs ? "8px 0" : "0 20px",
          }}
        >
          <div
            style={stepStyle(step === "Treatment")}
            onClick={() => setStep && setStep("Treatment")}
          >
            {/* Treatment Icon */}
            <span
              style={{
                fontSize: screens.xs ? "24px" : "30px",
                color: step === "Treatment" ? "#52c41a" : "#999", // Green for Active, Gray for Inactive
                marginRight: "8px",
              }}
            >
              <MedicineBoxFilled />
            </span>
            Treatment
          </div>
        </div>

        {/* RIGHT SECTION: Action Buttons - flex-shrink-0 to keep its size */}
        <div
          className="d-flex flex-shrink-0 align-items-center"
          style={{ gap: screens.xs ? "4px" : "8px", order: screens.xs ? 2 : 3 }}
        >
          <Button
            size="medium"
            type="primary"
            style={{
              ...buttonStyle,
              background: "grey",
              fontWeight: "bold",
              fontSize: "19.2px",
            }}
            onClick={() => autoSave("Hold")}
          >
            Hold
          </Button>

          {step=="Treatment" && <Button
            size="medium"
            type="primary"
            style={{
              ...buttonStyle,
              background: "grey",
              fontWeight: "bold",
              fontSize: "19.2px",
            }}
            onClick={() => autoSave("Lab_Report")}
          >
            In Lab
          </Button>}

          {step == "Symptoms" ? (
            <Button
              size="medium"
              type="primary"
              style={{
                ...buttonStyle,
                fontWeight: "bold",
                fontSize: "19.2px",
              }}
              onClick={() => {
                setStep("Treatment");
                autoSave();
              }}
            >
              Treat <ArrowRightOutlined style={{ marginLeft: "8px" }} />
            </Button>
          ) : (
            <Button
              size="medium"
              type="primary"
              style={{
                ...buttonStyle,
                fontWeight: "bold",
                fontSize: "19.2px",
              }}
              onClick={() => {
                previewRx();
                autoSave();
              }}
            >
              Preview Rx
            </Button>
          )}
        </div>
      </div>
    </Container>
  );
};

Consultant_Header.propTypes = {
  patient: PropTypes.object,
  previewRx: PropTypes.func,
  autoSave: PropTypes.func,
  refresh: PropTypes.func,
  step: PropTypes.string,
  setStep: PropTypes.func,
};

export default Consultant_Header;
